<login-home-navigation></login-home-navigation>

<section class="sptb" style="background-color: #fff;margin-top: 2%;">
<div class="container"> 
    <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4">
            <div class="rectangle-career">
                <p class="h21" style="padding-top:10%;padding-left:2%"><b>Work with us</b></p>
                <p style="padding-top:3%;padding-left:2%">Explore remote-friendly, flexible opportunities and join our mission to make work life simpler, more pleasant and more productive.</p>
                <p class="careerbtn" style="color:#fff;padding-left: 12%;padding-top: 3%;"><b>View Career</b></p>
            
            </div>
            <!-- <div class="careerbtn"></div> -->
        </div>
        <div class="col-lg-8 col-md-8 col-sm-8">
            <img src="assets/images/media/career.webp" height="100%" width="100%" >
        </div>

    </div>


    <div class="h2">Grow with us</div>
    <div class="col-lg-12 col-md-12 col-sm-12">
        <p>
            Indisourcing (ISSPL) is the fastest growing company focused on custom manufacturing services. Our mission is to provide the best B2B platform for Indian manufacturing companies to connect with domestic and international buyers. We are looking for candidates who are willing to work passionately in a fast-paced environment and are ready to enhance their skills by learning something new. Being a part of Indisourcing Solutions will allow you to unleash your potential and carve your own career.
        </p>

    </div>
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="h2">Current Openings</div>
        <p>
            Explore exciting career opportunities with us! We’re looking for passionate and talented individuals to join our growing team. Check out our latest openings and find the perfect role that matches your skills. Your next big move starts here!
        </p>
    </div>

</div>


</section>

<section class="sptb" style="background-color: #EFF9FF;" >
   <div class="container">
        <div class="row">

         <div class="col-lg-6 col-md-6 col-sm-6">
            <p class="h22">Inside Sales Executive:</p>
            <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-3">
                <p>1-3 Years</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <p>| Full Time </p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <p>| Pune</p>
                </div>
            </div>
            <p class="h22">Social Media Influencer:</p>
            <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <p>1-3 Years</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <p>| Full Time</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <p>| Pune</p>
                </div>
            </div>
            <p class="h22">Digital Marketing Executive :</p>
            <div class="row">
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <p>1-2 Years</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <p>| Part Time</p>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3">
                    <p>| Pune</p>
                </div>
            </div>
         </div>
    
         <div class="col-lg-6 col-md-6 col-sm-6">
            <img src="assets/images/media/hiring.webp" height="100%" width="100%"> 
         </div>

         <p><br>We have multiple open positions in marketing, web development do send your cv at at jobs@getyourvendor.com. </p>

        </div>  
   </div> 
</section>

<section class="sptb" style="background-color: #fff;" >
    <div class="container">
        <div class="h2">Why Join Us !!</div>
        <p>This is a unique opportunity to work on innovative and disruptive technology driven business solutions that are shaping the future of the manufacturing industry.</p>
     <div class="row">
 
     <div class="col-lg-6 col-md-6 col-sm-6">
         
         <div class="h22">Benefits Joining ISSPL team:</div>
         <div style="padding-top:3%"><li>Equal Opportunity Employer</li></div>
         <div><li>Flexible Vacation Plan</li></div>
         <div><li>Hybrid Working</li></div>
         <div><li>Techhnology Company</li></div>
         <div><li>Fast Growth in Career</li></div>
         <div><li>Premium Office Location</li></div>
         <div><li>Open Door Policy</li></div>

     </div>
     <div class="col-lg-6 col-md-6 col-sm-6">
         <img src="assets/images/media/joinus.webp" height="80%" width="80%">
     </div>
 
 
 
 
    </div> 
 
 </div>
     
 
 

 
 <section class="sptb" style="background-color: #EFF9FF;margin-top:2%">

    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
               <div class="">
                <div class="row">
                    <div class="col-lg-2 col-md-2 col-sm-2"> 
                            <p><img src="assets/images/media/rashmi.webp" style="margin-top: -10%;">
                    </div>
                    <div class="col-lg-10 col-md-10 col-sm-8">
                        <p><b>Rashmi, Account Manager</b></p>
                        <p>"Being part of a company with a clear vision and purpose gives real meaning to my work.The guidance and encouragement I've received here have been truly empowering."</p> 
                    </div>
                </div>
            </div>   
            
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="">
                 <div class="row">
                     <div class="col-lg-2 col-md-2 col-sm-2"> 
                             <p><img src="assets/images/media/lokendra.webp" style="margin-top: -10%;">
                     </div>
                     <div class="col-lg-10 col-md-10 col-sm-8">
                         <p>Lokendra, BDE</p>
                         <p>"As a Business Development Engineer at GetYourVendor, I engage with industry leaders daily, fostering learning and innovation in a dynamic environment. It's an ideal setting for those eager to lead in B2B manufacturing solutions."</p> 
                     </div>
                 </div>
             </div>   
             
             </div>
             <div class="col-lg-6 col-md-6 col-sm-6" style="margin-top:5%">
                <div class="">
                 <div class="row">
                     <div class="col-lg-2 col-md-2 col-sm-2"> 
                             <p><img src="assets/images/media/pradnya.webp" style="margin-top: -10%;">
                     </div>
                     <div class="col-lg-10 col-md-10 col-sm-8">
                         <p>Pradnya, Social Media Marketer</p>
                         <p>"The positive work environment, collaborative culture, and focus on innovation truly make it a great place to grow professionally. I look forward to contributing to the company’s vision and being a part of its continued success."</p> 
                     </div>
                 </div>
             </div>   
             
             </div>
             <div class="col-lg-6 col-md-6 col-sm-6" style="margin-top:5%">
                <div class="">
                 <div class="row">
                     <div class="col-lg-2 col-md-2 col-sm-2"> 
                             <p><img src="assets/images/media/shweta.webp" style="margin-top: -10%;">
                     </div>
                     <div class="col-lg-10 col-md-10 col-sm-8">
                         <p>Shweta, UI/UX Designer</p>
                         <p>"I'm grateful to be part of a company with a healthy and collaborative office culture. The environment supports both personal and professional growth, and I appreciate the opportunities provided to learn and improve."</p> 
                     </div>
                 </div>
             </div>   
             
             </div>
            

        </div>
        <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6" style="margin-top:5%">
            <div class="">
             <div class="row">
                 <div class="col-lg-2 col-md-2 col-sm-2"> 
                         <p><img src="assets/images/media/priya.webp" style="margin-top: -10%;">
                 </div>
                 <div class="col-lg-10 col-md-10 col-sm-8">
                     <p>Priya,Sr.Account Manager</p>
                     <p>"I'm grateful to be part of a company with a healthy and collaborative office culture. The environment supports both personal and professional growth, and I appreciate the opportunities provided to learn and improve."</p> 
                 </div>
             </div>
         </div>   
            <div class="col-lg-6 col-md-6 col-sm-6">
                <!-- <p>&#x201C;As a Business Development Engineer at GetYourVendor, I engage with industry leaders daily, fostering learning and innovation in a dynamic environment. It's an ideal setting for those eager to lead in B2B manufacturing solutions.&#x201D;</p> -->
                 <!-- <p class="rectangle-562"> <img src="assets/images/media/rashmi.webp" style="margin-top: -10%;"></p> -->
            </div>
          

        </div>
      
    </div>

    </div>

 </section>

 <section class="sptb" style="background-color: #fff;" >
    <div class="h2">Our Core Values</div>
    <div class="container">
        <div class="row">
              <div class="col-lg-3 col-md-3 col-sm-3 rcorners1" >
                <div style="text-align:center">
                    <img src="assets/images/media/smile1.webp" alt="empathy" width="25%" height="25%">
                </div>
                <div style="text-align: center;">
                    <p><b>Empathy</b></p>
                    <p>Treat people with courtesy and kindness while trying to understand where they're coming from.</p>
                </div>
              </div>  
              <div class="col-lg-3 col-md-3 col-sm-3 rcorners1">
                <div style="text-align: center;">
                    <img src="assets/images/media/smile2.webp" alt="transparency" width="25%" height="25%">
                </div>
                <div style="text-align: center;">
                    <p><b>Transparency</b></p>
                    <p>Build trust and commitment through openness, dialogue, and accountability, within our team and with our customers</p>
                </div>
                
              </div>  
              <div class="col-lg-3 col-md-3 col-sm-3 rcorners1">
                <div style="text-align: center;">
                    <img src="assets/images/media/smile3.webp" alt="responsibility" width="25%" height="25%">
                </div>
                <div style="text-align: center;">
                    <p><b>Responsibility</b></p>
                    <p>When people act and think like owners. everyone feels empowered to make our company the best it can be.</p>
                </div>
              </div>  
              <div class="col-lg-3 col-md-3 col-sm-3 rcorners1">
                <div style="text-align: center;">
                    <img src="assets/images/media/smile4.webp" alt="awkwardness" width="25%" height="25%">
                </div>
                <div style="text-align: center;">
                    <p><b>Growth</b></p>
                    <p>Personal growth is a big part of the career journey.</p>
                </div>
              </div>  


        </div>
        
    </div>

 </section>


<login-home-footer></login-home-footer>